module.exports = global["mapboxgl"] = require("-!./mapbox-gl.js");